// removed by extract-text-webpack-plugin
module.exports = {"imageArea":"_2GAAcYD2eBc7639YnBcLZO","is-on-screen":"_3_OqsU1uHEa1yDPpxY2l0e","image":"hKFbEgXFBefQNkFiOTt3P","block":"_2htH0S04cq7ghXHlUXhNab","inList":"LbLUlDSdNCJtnaRGC5imG","textContent":"_2DSCn_rOhIJr_ucKWYfIZd","projectHeading":"_3h2gJMwV52TWtRnszE5ABC","text":"_26paTFeCQyR-mGbda4GRsl","button":"du37SouANEkcSwZf4t16p","icon":"VilJxYqRk0lFh_WOlJhqn","darkgray":"_2jfQG_10ClmvBse4GXOzgz","inner":"_14rGVRhE03mnicbbF3NkOQ","imageWrapper":"_30bd8AZf2qlku9iXGycqzK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HighlightedProjectBlock/HighlightedProjectBlock.module.scss
// module id = 776
// module chunks = 0